import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { CmsConfig, provideConfig } from '@spartacus/core'
import { MaterialModule } from '../../../shared/material.module'
import { CustomParagraphComponent } from './custom-paragraph.component'

@NgModule({
  imports: [CommonModule, MaterialModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CMSParagraphComponent: {
          component: CustomParagraphComponent
        }
      }
    })
  ],
  declarations: [CustomParagraphComponent],
  exports: [CustomParagraphComponent]
})
export class CustomParagraphModule {}
